module.exports = __webpack_public_path__ + "img/2-3.9cd48143.png";